import { usePageData } from "../../../contexts/PageData";
import styled from "@emotion/styled";

import { Link } from "react-router-dom";

import { Grid, Card, CardHeader, CardContent, CardActions, Button, Typography, Divider, IconButton, Tooltip, lighten } from "@mui/material";

import { CardBlock, CardBlockHeader, CardBlockContainer, CardSpacer } from "../../../utils/utilities/CardComponents";

import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import HideSourceRoundedIcon from '@mui/icons-material/HideSourceRounded';
import LinkOffRoundedIcon from '@mui/icons-material/LinkOffRounded';
import PaymentsRoundedIcon from '@mui/icons-material/PaymentsRounded';

import AddIcon from '@mui/icons-material/AddRounded';

import useSnackbarStore from "../../../store/snackbar";

import { BasicFlex } from "../../../utils/Common";

import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";

import { getAppliedPayments } from "../apiService";

import MultiStatusChip from "../../../utils/utilities/MultiStatusChip";

import { formatCurrency, formatGenericDate } from "../../../utils/util";

import { methods } from "../../Payments/helpers";

import AvailablePayments from "../Components/AvailablePayments";

import AppliedPayments from "../Components/AppliedPayments";

const Actions = styled(BasicFlex)`
  gap: 1rem;
  width: 10rem;
`;


const PaymentsTab = () => {

 const { data = {} } = usePageData();

let customer = data?.customer || {};

 const { data: payments } = useQuery({
  queryKey: ['invoices', data.invoice_id],
  queryFn: () => getAppliedPayments(data.invoice_id),
  enabled: !!data.invoice_id
 });

 console.log(payments, "payments");

  const invoiceBlock = [
    {header: "Invoice Total",  info: data.total, dataType: "currency"},
    {header: "Paid Status", info: <MultiStatusChip value={data.paid_status} values={[{value: "unpaid", label: "Unpaid", status: "error"}, {value: "partially_paid", label: "Partially Paid", status: "warning"}, {value: "paid", label: "Paid", status: "success"}]} />},
    {header: "Paid Amount", info: data.total_paid, dataType: "currency"},
    {header: "Balance", info: data.balance, dataType: "currency"},
  ]

 return (
  <Grid container spacing={3}>
    <Grid size={{xs: 12, md: 8}}>
      <Card elevation={0} sx={{backgroundColor: "transparent"}}>
      <CardHeader title="List of Applied Payments" sx={{p: 1}} />
        <AppliedPayments payments={payments} />
      </Card>
    </Grid>

    <Grid size={{xs: 12, md: 4}}>
      <Card variant='outlined'>
        <CardHeader title="Balance and Payments" />
        <CardContent>
          <CardBlockContainer>
            {invoiceBlock.map((block) => (
              <CardBlock key={block.header} header={block.header} info={block.info} dataType={block.dataType} />
            ))}
          </CardBlockContainer>
        </CardContent>

        <CardActions sx={{display: "flex", flexDirection: "column"}}>
          {/* <Button fullWidth variant="outlined" startIcon={<AddIcon />}>Add New Payments</Button> */}
        <Link to={`/payments/edit`} state={{customer_id: customer.customer_id?.toString(), client_name: customer.full_name, mobile_phone: customer.mobile_phone, email: customer.email}} style={{width: "100%"}} >
            <Button variant='contained' fullWidth startIcon={<PaymentsRoundedIcon />}>Add New Payment</Button>
          </Link>
        </CardActions>
      </Card>
    </Grid>

    <Grid size={{xs: 12, md: 8}}>
      {data.balance > 0 ? <AvailablePayments /> : null}
    </Grid>

  </Grid>
 )
};

export default PaymentsTab;